<app-dialog>
  <app-dialog-title>
    {{ 'ACCOUNT.FOLDER.QR_URLS.DIALOGS.ACTIVATE_DIALOG.TITLE' | translate }}
  </app-dialog-title>
  <app-dialog-content>
    <div class="activate-groups">
      <div class="activate-groups__toolbar">
        <mat-form-field
          class="activate-groups__search"
          appearance="outline"
          subscriptSizing="dynamic">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            data-testid="input-activate-groups-search"
            [placeholder]="
              'ACCOUNT.FOLDER.QR_URLS.DIALOGS.ACTIVATE_DIALOG.SEARCH_PLACEHOLDER' | translate
            "
            [ngModel]="query()"
            (ngModelChange)="query.set($event)" />
        </mat-form-field>
        <button
          matButton
          type="button"
          data-testid="btn-activate-groups-select-all"
          [disabled]="!visibleGroups().length"
          (click)="toggleAllVisible()">
          {{
            (allVisibleSelected()
              ? 'ACCOUNT.FOLDER.QR_URLS.DIALOGS.ACTIVATE_DIALOG.DESELECT_ALL'
              : hasQuery()
                ? 'ACCOUNT.FOLDER.QR_URLS.DIALOGS.ACTIVATE_DIALOG.SELECT_ALL_FILTERED'
                : 'ACCOUNT.FOLDER.QR_URLS.DIALOGS.ACTIVATE_DIALOG.SELECT_ALL'
            ) | translate
          }}
        </button>
      </div>

      <div class="activate-groups__list">
        @for (section of sections(); track section.uuid) {
          <h3 class="activate-groups__section-header">
            <span>{{ section.name }}</span>
            <span>{{ section.groups.length }}</span>
          </h3>
          <ul class="activate-groups__rows">
            @for (group of section.groups; track group.uuid) {
              <li>
                <mat-checkbox
                  class="activate-groups__row"
                  [checked]="isSelected(group)"
                  [attr.data-testid]="'checkbox-activate-group-' + group.uuid"
                  (change)="toggle(group)">
                  <span class="activate-groups__row-content">
                    <span class="activate-groups__row-name">{{ group.name }}</span>
                    @if (group.venuesCount > 0) {
                      <span class="activate-groups__chip">
                        {{
                          'ACCOUNT.FOLDER.QR_URLS.TABLE.UNIT_COUNT'
                            | translate: { count: group.venuesCount, childrenName: unitNamePlural }
                        }}
                      </span>
                    }
                  </span>
                </mat-checkbox>
              </li>
            }
          </ul>
        }

        @if (!visibleGroups().length) {
          <p class="activate-groups__no-results" data-testid="text-activate-groups-empty">
            {{
              'ACCOUNT.FOLDER.QR_URLS.DIALOGS.ACTIVATE_DIALOG.NO_RESULTS'
                | translate: { query: query() }
            }}
          </p>
        }
      </div>
    </div>
  </app-dialog-content>
  <app-dialog-actions>
    <span class="activate-groups__selected-count" data-testid="text-activate-groups-count">
      {{
        'ACCOUNT.FOLDER.QR_URLS.DIALOGS.ACTIVATE_DIALOG.SELECTED_COUNT'
          | translate: { selected: selectedCount(), total: totalCount() }
      }}
    </span>
    <button
      matButton="outlined"
      type="button"
      class="me-1"
      data-testid="btn-activate-groups-cancel"
      (click)="hide()">
      {{ 'ACCOUNT.FOLDER.QR_URLS.BUTTONS.CANCEL' | translate }}
    </button>
    <button
      matButton="filled"
      type="button"
      data-testid="btn-activate-groups-save"
      [disabled]="!hasChanges() || saving()"
      (click)="save()">
      {{ 'SHARED.SYSTEM.SAVE' | translate }}
    </button>
  </app-dialog-actions>
</app-dialog>
